import { FormProvider } from "react-hook-form";
import { UserRegistrationDetails } from "../../../../../../types/userTypes";
import {
  AsyncCallArgs,
  BoxSpg,
  getFieldError,
  GridContainer,
  GridItem,
  handleFormSubmission,
  InputFormField,
  shouldShowFieldError,
  SubmitFormButton,
  useAsyncCall,
  useReactHookForm,
} from "@duosoftbg/nacid-components";
import React from "react";
import { useTranslation } from "react-i18next";
import { Alert, Container, Typography } from "@mui/material";
import { resetPasswordInitialValues } from "../../../../../../init/resetPasswordInitialValues";
import { resetPassword } from "../../../../../../axios/api/services";
import { useGoogleReCaptcha } from "react-google-recaptcha-v3";
import { useSearchParams } from "react-router-dom";
import { createPasswordConfirmationValidationSchema } from "../../../../../../yup/schema/password/base/passwordConfirmationValidationSchema";

const ResetPasswordForm = ({ statusUpdate, userUpdate }) => {
  const { t } = useTranslation();
  const { asyncCall } = useAsyncCall();
  const { executeRecaptcha } = useGoogleReCaptcha();
  const [searchParams] = useSearchParams();

  const { methods } = useReactHookForm<UserRegistrationDetails>({
    defaultValues: resetPasswordInitialValues,
    validationSchema: createPasswordConfirmationValidationSchema,
  });

  const onSubmit = async (values) => {
    const token = await executeRecaptcha("PortalResetPasswordFormSubmit");
    const key = searchParams.get("key");
    const asyncRegistration: AsyncCallArgs = {
      withGlobalBackdrop: true,
      promise: resetPassword(values, token, key),
      reactHooksForm: { methods },
      onSuccess: (response) => {
        statusUpdate(response.status);
        userUpdate(response.user);
      },
    };
    asyncCall(asyncRegistration);
  };

  return (
    <Container component={"main"} maxWidth={"xs"}>
      <BoxSpg
        sx={{
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
        }}
      >
        <FormProvider {...methods}>
          <form onSubmit={handleFormSubmission({ methods, onSubmitFn: onSubmit, t })}>
            {shouldShowFieldError("captchaToken", methods.formState, methods.getFieldState) ? (
              <Alert severity={"error"}>{getFieldError("captchaToken", methods.getFieldState)}</Alert>
            ) : null}
            <GridContainer spacing={3}>
              <GridItem sm={12} md={12}>
                <BoxSpg style={{ whiteSpace: "pre-line" }}>
                  <InputFormField
                    required={true}
                    type={"password"}
                    fieldName={"password"}
                    labelCode={"l.user.password"}
                  />
                </BoxSpg>
              </GridItem>
              <GridItem sm={12} md={12}>
                <InputFormField
                  required={true}
                  type={"password"}
                  fieldName={"confirmPassword"}
                  labelCode={"l.user.confirmPassword"}
                />
              </GridItem>
              <GridItem sm={12} md={12}>
                <Typography align={"left"}>
                  <SubmitFormButton fullWidth label={"l.btn.submit"} />
                </Typography>
              </GridItem>
            </GridContainer>
          </form>
        </FormProvider>
      </BoxSpg>
    </Container>
  );
};

export default ResetPasswordForm;
